import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

const Navbar = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { name: 'About', path: '/about' },
    { name: 'Accreditation', path: '/accreditation' },
    { name: 'Certifications', path: '/certifications' },
    { name: 'Standards & Ethics', path: '/standards' },
    { name: 'Find a Coach', path: '/find-coach' },
    { name: 'Membership', path: '/membership' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <div className="flex flex-col">
              <div className="text-base font-bold text-[#1e3a5f] leading-tight">
                ICCAC
              </div>
              <div className="text-[8px] text-gray-600 leading-tight max-w-[160px]">
                International Consciousness & Coaching Accreditation Council
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1 flex-1 justify-end mr-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-2 py-2 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  isActive(link.path)
                    ? 'text-[#1e3a5f] bg-blue-50'
                    : 'text-gray-700 hover:text-[#1e3a5f] hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/accreditation"
              className="bg-[#1e3a5f] text-white px-4 py-2 rounded-md font-medium hover:bg-[#2d5380] transition-colors whitespace-nowrap text-xs ml-2"
            >
              Get Accredited
            </Link>
          </div>

          {/* Mobile menu button - positioned absolutely on right */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 ml-auto"
            aria-label="Toggle menu"
          >
            <svg
              className="h-7 w-7"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              viewBox="0 0 24 24"
              stroke="#1e3a5f"
              style={{ stroke: '#1e3a5f' }}
            >
              {mobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive(link.path)
                    ? 'text-[#1e3a5f] bg-blue-50'
                    : 'text-gray-700 hover:text-[#1e3a5f] hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/accreditation"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full text-center bg-[#1e3a5f] text-white px-3 py-2 rounded-md font-medium hover:bg-[#2d5380] mt-4"
            >
              Get Accredited
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;